// extracted by mini-css-extract-plugin
module.exports = {"DfmPanel":"ZMIoioSNAGxKwtXEl81nuA=="};